<script setup lang="ts">
import {ref} from "vue";
import EmailPassword from "supertokens-web-js/recipe/emailpassword";
import {showErrorAlert, showSuccessAlert} from "@/helpers/SweetAlertHelper";
import SimpleLayout from "@/layouts/simple/SimpleLayout.vue";
import logoImage from "@/assets/images/BeePallet_Logo_Black.png";
import {useRouter} from "vue-router";

const email = ref("");
const isSubmitting = ref(false);
const router = useRouter();
const handleForgotPassword = async () => {
  if (!email.value) {
    showErrorAlert("Por favor, ingresa tu correo electrónico.");
    return;
  }

  isSubmitting.value = true;

  try {
    await EmailPassword.sendPasswordResetEmail({formFields: [{id: "email", value: email.value}]});
    showSuccessAlert("", "Si este correo existe, recibirás un enlace para restablecer tu contraseña.");
  } catch (error) {
    showErrorAlert("Error al enviar el correo de recuperación.");
  } finally {
    isSubmitting.value = false;
    router.push({name: "login"});
  }
};
</script>

<template>
  <SimpleLayout>
    <template #content>
      <div class="login-page">
        <div class="login-container">
          <router-link to="home">
            <img :src="logoImage" class="beepallet-logo" alt="Logo de BeePallet">
          </router-link>
          <form class="login-form" @submit.prevent="handleForgotPassword">
            <div class="input_container">

              <label class="input_label" for="username">Ingresa tu correo electrónico para recibir un enlace de recuperación.</label>
              <input type="text" class="input-field is-placeholder" id="email" v-model="email" required />
            </div>
            <button type="submit" class="btn-primary-green">Enviar enlace de recuperación</button>
          </form>
        </div>
      </div>
    </template>
  </SimpleLayout>
</template>

<style scoped lang="scss">
@import 'ForgotPasswordPage';
</style>